import { EVENTS } from './events.js';
import { normaliseRoomCode, PUBLIC_ROOM, type ClientMessage } from './protocol.js';
const obj = (v: unknown): v is Record<string, unknown> =>
  !!v && typeof v === 'object' && !Array.isArray(v);
const finite = (v: unknown): v is number => typeof v === 'number' && Number.isFinite(v);
const text = (v: unknown, max: number): v is string => typeof v === 'string' && v.length <= max;
const programme = (v: unknown) =>
  ['full', 'day1', 'day2', ...EVENTS.map((e) => e.id)].includes(v as string);
/** Validate the wire format before any application code reads its fields. */
export function parseClientMessage(v: unknown): ClientMessage | null {
  if (!obj(v)) return null;
  switch (v.type) {
    case 'join':
      if (
        !text(v.name, 80) ||
        !text(v.kit, 32) ||
        (v.token !== undefined && !text(v.token, 256)) ||
        (v.resume !== undefined && !text(v.resume, 256)) ||
        (v.createRoom !== undefined && typeof v.createRoom !== 'boolean') ||
        (v.room !== undefined &&
          (typeof v.room !== 'string' || (v.room !== PUBLIC_ROOM && !normaliseRoomCode(v.room)))) ||
        (v.createRoom === true && v.room !== undefined)
      )
        return null;
      break;
    case 'setKit':
      if (!text(v.kit, 32)) return null;
      break;
    case 'setOptions': {
      const o = v.options;
      if (
        !obj(o) ||
        (o.programme !== undefined && !programme(o.programme)) ||
        (o.fillWithBots !== undefined && typeof o.fillWithBots !== 'boolean') ||
        (o.botLevel !== undefined &&
          !['club', 'county', 'national', 'olympic'].includes(o.botLevel as string)) ||
        (o.strictHurdles !== undefined && typeof o.strictHurdles !== 'boolean')
      )
        return null;
      break;
    }
    case 'ready':
      if (typeof v.ready !== 'boolean') return null;
      break;
    case 'input': {
      const b = v.batch;
      if (
        !obj(b) ||
        !Number.isSafeInteger(b.eventIndex) ||
        (b.eventIndex as number) < 0 ||
        (b.seq !== undefined && (!Number.isSafeInteger(b.seq) || (b.seq as number) < 0)) ||
        !Array.isArray(b.presses) ||
        b.presses.length > 40 ||
        !Array.isArray(b.actions) ||
        b.actions.length > 10
      )
        return null;
      if (
        !b.presses.every((p) => obj(p) && (p.key === 0 || p.key === 1) && finite(p.t)) ||
        !b.actions.every((a) => obj(a) && typeof a.down === 'boolean' && finite(a.t))
      )
        return null;
      break;
    }
    case 'setHeight':
      if (!finite(v.height) || v.height < 0.5 || v.height > 7) return null;
      break;
    case 'ping':
      if (!finite(v.t)) return null;
      break;
    case 'start':
    case 'backToLobby':
    case 'skipBot':
    case 'nextSeason':
    case 'leave':
    case 'requestLeague':
      break;
    default:
      return null;
  }
  return v as unknown as ClientMessage;
}
